import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useResponsive } from './hooks/useResponsive';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../Store/Actions/App';
import { FaLongArrowAltRight } from 'react-icons/fa';

// UpdateService dialog component
const SelectAgencyView = (props) => {

// set vars from props
const {
	dialog,
	setDialog,
	scrollBlock,
	setCurrentAgency,
	currentAgency,
	setAlert,
	setAlertTitle,
	setAlertBody,
	retrieveSelectableCompanies,
	retrieveSelectableCompanyUsers
} = props;

// No mobile a ConfirmDialog precisa ocupar a largura. O contentStyle fixo de
// 30vw (bom no desktop) espreme o conteúdo numa coluna fininha e o restante da
// caixa fica transparente, mostrando a modal de trás (bug gráfico).
const { isMobile } = useResponsive();
const confirmContentStyle = isMobile
	? { maxWidth: "85vw", width: "85vw" }
	: { maxWidth: "30vw", width: "30vw" };

const [agency, setAgency] = React.useState('');
const [agencyEmployee, setAgencyEmployee] = React.useState('');
const [loading, setLoading] = React.useState(true);
const [loadingEmployees, setLoadingEmployees] = React.useState(false);
const [saving, setSaving] = React.useState(false);
const [selectedAgency, setSelectedAgency] = React.useState(''); 
const [selectedEmployee, setSelectedEmployee] = React.useState(''); 
const [agencyItems, setAgencyItems] = React.useState([]);
const [employeeItems, setEmployeeItems] = React.useState([]);

// ---------------------------------------------------------------------------
// Guardas de geração (TD-036)
// ---------------------------------------------------------------------------
//
// Esta tela tem UMA invariante: o funcionário confirmado tem que pertencer à agência confirmada.
// Sem guarda, ela quebrava assim: o master abre a agência Alfa, muda para Beta antes de a resposta
// chegar, e a resposta atrasada da Alfa sobrescreve a lista já carregada da Beta. Como o
// auto-select escolhe sozinho quando a agência tem um funcionário só, a lista errada virava
// SELEÇÃO errada — e o "Confirmar" aplicava o par cruzado, sem nada na tela denunciando (o nome da
// agência continua certo; só a pessoa está trocada).
//
// Cada disparo leva um número; ao voltar, só é aceita a resposta da geração mais recente.
//
// Por que não o `useAbortController` do projeto: os dois thunks montam a chamada do axios sem
// aceitar `signal`, então passar um exigiria mudar as actions junto. A guarda de geração resolve o
// problema inteiro aqui dentro e não depende da feature flag ENABLE_REQUEST_CANCELLATION.
const geracaoAgencias = React.useRef(0);
const geracaoFuncionarios = React.useRef(0);


var navigate = useNavigate();


const applyAgencyAction = () => {
	if (!selectedAgency.code) {
		setAlert(true);
		setAlertTitle("Ops! Ocorreu um problema!");
		setAlertBody("Você precisa selecionar uma agência para confirmar!");
		return;
	}

	if (!selectedEmployee.code) {
		setAlert(true);
		setAlertTitle("Ops! Ocorreu um problema!");
		setAlertBody("Você precisa selecionar um funcionário da agência selecionada para confirmar!");
		return;
	}

	confirmDialog({
		message: 'Ao confirmar uma nova agência um novo processo de reserva será iniciado. Se vocês está no meio de um processo de reserva, todas as informações preenchidas até agora serão perdidas. Deseja continuar?',
		header: 'Confirma mudança de agência?',
		icon: 'pi pi-exclamation-triangle',
		acceptLabel: "Sim, continuar",
		rejectLabel: "Cancelar",
		accept: () => finalizeAgencyAction(),
		reject: () => {},
		contentStyle: confirmContentStyle
	});
};

const finalizeAgencyAction = () => {
	setSaving(true);

	setTimeout(function () {

		const currentAgencyObj = {
			agencyCode: selectedAgency.code,
			agencyName: selectedAgency.name,
			employeeName: selectedEmployee.name,
			employeeCode: selectedEmployee.code,
		};

		setCurrentAgency(currentAgencyObj);
		setDialog('selectAgencyModal', false);
		setSaving(false);

		navigate("/order");

	}, 500);
};

// Sai do "modo agência" (SUDO): limpa a agência/funcionário ativos para o
// master voltar a operar como ele mesmo, sem nenhuma agência selecionada.
// Espelha o resetCurrentAgencyAction do Layout (Desktop.js / mobile) —
// setCurrentAgency({}) + navega para /order. Recurso antes disponível só no
// header/mobile; agora acessível também de dentro do próprio modal.
const exitAgencyMode = () => {
	setCurrentAgency({});
	setDialog('selectAgencyModal', false);

	// Reset Fields
	setSelectedAgency("");
	setSelectedEmployee("");
	setAgencyItems([]);
	setEmployeeItems([]);
	setLoadingEmployees(false);

	navigate("/order");
};


const close = ()=> {
	// setValidateRegistry(false);
	setDialog('selectAgencyModal',false);
	
	// Reset Fields
	setSelectedAgency("");
	setSelectedEmployee("");
	setAgencyItems([]);
	setEmployeeItems([]);
	setLoadingEmployees(false);


	setTimeout(function() {
		if (scrollBlock) {
			document.body.classList.add('p-overflow-hidden');	
		} // end if 
	},300);
}	
	
const footerContent = (
	<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: '0.5rem' }}>

			{/* Esquerda: sair do modo agência (só quando há agência ativa).
			    Quando não há, o div vazio mantém o space-between empurrando
			    Fechar/Confirmar para a direita. */}
			<div style={{ textAlign: 'start' }}>
				{currentAgency && currentAgency.agencyCode &&
					<Button label="Sair do modo agência" disabled={saving} icon="pi pi-sign-out" className="p-button-text p-button-secondary" onClick={() => exitAgencyMode()} />
				}
			</div>

			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0.5rem' }}>
				<ConfirmDialog />
				<Button label="Fechar" disabled={saving} icon="pi pi-times" className="p-button-text" onClick={() => close()} />
				<Button label="Confirmar" icon="pi pi-check" loading={saving} onClick={() => applyAgencyAction()} />
			</div>

	</div>
);

// Execute when dialog opens
React.useEffect(() => {

	setSaving(false);
	
  // Runs when UNMOUNT component
  return () => {
    
	setSaving(false);
	
	// Reset Fields
	setSelectedAgency("");	
	setSelectedEmployee("");
	setAgencyItems([]);
	setEmployeeItems([]);
			
	
  };	
			
},[]);


React.useEffect(() => {

	// Fechar (ou reabrir) invalida qualquer busca em andamento: a resposta que chegar depois é de
	// uma sessão de escolha que não existe mais.
	const minhaGeracao = ++geracaoAgencias.current;

	if (dialog.target === 'selectAgencyModal' && dialog.status) {

		setSelectedAgency("");
		setSelectedEmployee("");
		setAgencyItems([]);
		setEmployeeItems([]);
		setLoading(true);

		// Busca agências
		props.retrieveSelectableCompanies().then((result) => {
			if (minhaGeracao !== geracaoAgencias.current) return;   // resposta obsoleta

			if (result.success) {
				const items = result.data;
				setAgencyItems(items);

				// ✅ Se já havia uma agência ativa, selecionar automaticamente
				if (currentAgency && currentAgency.agencyCode) {
					const preSelectedAgency = items.find(ag => ag.code === currentAgency.agencyCode);
					if (preSelectedAgency) {
						setSelectedAgency(preSelectedAgency);
					}
				}
			} else {
				setAgencyItems([]);
				setAlert(true);
				setAlertTitle("Erro");
				setAlertBody("Não foi possível carregar a lista de agências. Tente novamente.");
			}
		}).finally(() => {
			// Também sob a guarda: liberar o dropdown por conta de uma resposta velha mostraria
			// "pronto" com a lista da busca anterior.
			if (minhaGeracao !== geracaoAgencias.current) return;
			setLoading(false);
		});


	}

}, [dialog]);

React.useEffect(() => {

	// Trocar de agência — ou limpar a seleção — invalida a busca anterior. O contador sobe ANTES do
	// `if` de propósito: sair de uma agência para nenhuma também tem que descartar o que vier.
	const minhaGeracao = ++geracaoFuncionarios.current;

	if (selectedAgency && selectedAgency.code) {
		const agenciaDestaBusca = selectedAgency.code;

		setSelectedEmployee("");
		setEmployeeItems([]);
		setLoadingEmployees(true);

		props.retrieveSelectableCompanyUsers(agenciaDestaBusca).then((result) => {
			if (minhaGeracao !== geracaoFuncionarios.current) return;   // resposta de outra agência

			if (result.success) {
				setEmployeeItems(result.data);

				// ✅ Se já havia um funcionário salvo, selecionar — mas só quando a agência que
				// acabou de carregar É a agência ativa. `code` de funcionário é PK global, então
				// hoje um código de outra agência não casaria; a condição existe para que a
				// invariante fique escrita, e não dependendo de um detalhe do backend.
				const carregouAAgenciaAtiva = currentAgency && currentAgency.agencyCode === agenciaDestaBusca;
				if (carregouAAgenciaAtiva && currentAgency.employeeCode) {
					const preSelectedEmployee = result.data.find(emp => emp.code === currentAgency.employeeCode);
					if (preSelectedEmployee) {
						setSelectedEmployee(preSelectedEmployee);
						return;
					}
				}

				// ✅ Se só há um funcionário, seleciona automaticamente
				if (result.data.length === 1) {
					setSelectedEmployee(result.data[0]);
				}
			} else {
				setEmployeeItems([]);
				setAlert(true);
				setAlertTitle("Erro");
				setAlertBody("Não foi possível carregar os funcionários da agência selecionada.");
			}
		}).finally(() => {
			if (minhaGeracao !== geracaoFuncionarios.current) return;
			setLoadingEmployees(false);
		});
	}


}, [selectedAgency]);

	
	return (
	<>
			<Dialog header="Selecione a agência ativa" closeOnEscape={false} draggable={false} closable={false} visible={dialog.target == 'selectAgencyModal' && dialog.status} style={{ width: '35vw' }} breakpoints={{ '1400px': '45vw','960px': '50vw', '641px': '100vw' }} onHide={() => close()} footer={footerContent} >
			
			
			<Box
				  sx={{
					width: "100%",
				  }}
				  className="terms"
				>
				
					<div className="termsModalIntro"> Selecione a agência e o funcionário para realizar compras como se fosse a agência. <br /><br /> <small> O pagamento do pedido deverá ser feito diretamente pela agência após a reserva. </small> </div>
				
					<Divider />
					
					<span className="p-float-label" style={{marginTop:"1.975rem"}}>
						<Dropdown
							id="agencySelector"
							disabled={saving || loading}
							value={selectedAgency}
							onChange={(e) => setSelectedAgency(e.value)}
							options={agencyItems}
							optionLabel="name"
							placeholder={loading ? "Carregando agências..." : "Selecione"}
							dropdownIcon={loading ? "pi pi-spin pi-spinner" : "pi pi-chevron-down"}
							className="w100"
							filter={true}
							filterLocale="pt-BR"
							emptyFilterMessage="Nenhum resultado"
							emptyMessage="Nenhum resultado"
							itemTemplate={(option) => (
								<div className="dropdown-agency-template">
								<div style={{ fontWeight: 500 }}>{option.name}</div>
								{option.tradingName && (
									<div style={{ fontSize: '0.75rem', color: '#777' }}>Nome Fantasia: {option.tradingName}</div>
								)}
								</div>
							)}
						/>
						<label htmlFor="agencySelector">Agência</label>
					</span>	
					
					<span className="p-float-label" style={{marginTop:"1.975rem"}}>
						<Dropdown id="employeeSelector" disabled={!selectedAgency || saving || loadingEmployees} value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.value)} options={employeeItems} optionLabel="name" placeholder={loadingEmployees ? "Carregando funcionários..." : "Selecione"} dropdownIcon={loadingEmployees ? "pi pi-spin pi-spinner" : "pi pi-chevron-down"} className="w100" filter={true} filterLocale="pt-BR" emptyFilterMessage="Nenhum resultado" emptyMessage="Nenhum resultado" ></Dropdown>
						<label htmlFor="employeeSelector">Funcionário</label>
					</span>						
					 
			</Box> 
			
						
            </Dialog>	
	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  currentAgency:store.appReducer.currentAgency
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(SelectAgencyView);	
